import React from 'react';
import {ThumbDownIcon, ThumbUpIcon} from "@heroicons/react/solid";

// Types ----

type LikeDislikeProps = {
  score?: number
};

// Component ----

function LikeDislike({score}: LikeDislikeProps) {
  return Number(score) > 0 ?
    <ThumbUpIcon className="h-3 text-green-500" /> :
    <ThumbDownIcon className="h-3 text-red-500" />
}

// Export ----

export default LikeDislike;